import Layout from 'components/layouts/Layout';
import About from 'pages/about/About';
import Accounts from 'pages/admin/Accounts';
import AdminIndex from 'pages/admin/Admin';
import AllTransactions from 'pages/admin/Transactions';
import Users from 'pages/admin/Users';
import ChangePassword from 'pages/auth/ChangePassword';
import LoginComponent from 'pages/auth/Login';
import RegisterComponent from 'pages/auth/Register';
import ResetPassword from 'pages/auth/ResetPassword';
import VerifyEmail from 'pages/auth/VerifyEmail';
import Contact from 'pages/contact/Contact';
import Account from 'pages/dashboard/Account';
import Dashboard from 'pages/dashboard/Index';
import Index from 'pages/home/Index';
import Investment from 'pages/investment/Investment';
import Settings from 'pages/settings/Index';
import Stocks from 'pages/stock/Stocks';
import Transactions from 'pages/transaction/Transactions';
import Wallet from 'pages/wallet/Index';
import Withdraw from 'pages/withdraw/Withdraw';
import { AuthRoute } from 'routes/AuthRoutes';
import { ProtectedRoute } from 'routes/ProtectedRoute';

const Routes = [
  {
    path: '/',
    element: (
      <Layout>
        <Index />
      </Layout>
    ),
  },
  {
    path: '/about',
    element: (
      <Layout>
        <About />
      </Layout>
    ),
  },
  {
    path: '/contact',
    element: (
      <Layout>
        <Contact />
      </Layout>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthRoute>
        <LoginComponent />
      </AuthRoute>
    ),
  },
  {
    path: '/register',
    element: (
      <AuthRoute>
        <RegisterComponent />
      </AuthRoute>
    ),
  },
  {
    path: '/verify-email',
    element: (
      <AuthRoute>
        <VerifyEmail />
      </AuthRoute>
    ),
  },
  {
    path: '/reset-password',
    element: (
      <AuthRoute>
        <ResetPassword />
      </AuthRoute>
    ),
  },
  {
    path: '/change-password',
    element: (
      <AuthRoute>
        <ChangePassword />
      </AuthRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute type="investor">
        <Dashboard />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '',
        Index: true,
        element: <Account />,
      },
      {
        path: 'invest',
        element: <Investment />,
      },
      {
        path: 'wallet',
        element: <Wallet />,
      },
      {
        path: 'transactions',
        element: <Transactions />,
      },
      {
        path: 'stocks',
        element: <Stocks />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'withdraw',
        element: <Withdraw />,
      },
    ],
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute type="admin">
        <AdminIndex />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '',
        Index: true,
        element: <Users />,
      },
      {
        path: 'users',
        element: <Users />,
      },
      {
        path: 'accounts',
        element: <Accounts />,
      },
      {
        path: 'transactions',
        element: <AllTransactions />,
      },
    ],
  },
];

export default Routes;
